$(document).ready(function () {
  let popImageInterval = setInterval(() => {
    if ($("#wisepops-root.wisepops-root").length) {
      $("#wisepops-root.wisepops-root img").each(function () {
        var datasrc = $(this).attr("src");
        $(this).attr("data-src", datasrc);
        $(this).attr("src", "");
        $(this).addClass("lazyload");
      });

      $("#wisepops-root.wisepops-root").attr("style", "display: block");
      clearInterval(popImageInterval);
    }
  }, 300);
});

$(document).ready(function () {
  var lazyBackgrounds = [].slice.call(
    document.querySelectorAll(".lazy-background")
  );

  if ("IntersectionObserver" in window) {
    let lazyBackgroundObserver = new IntersectionObserver(function (
      entries,
      observer
    ) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add("visible");
          lazyBackgroundObserver.unobserve(entry.target);
        }
      });
    });

    lazyBackgrounds.forEach(function (lazyBackground) {
      lazyBackgroundObserver.observe(lazyBackground);
    });
  }
});



// // FIX FOR PRODUCT PHOTO IMAGES 
// $(document).ready(function () {
//     if($(window).width() < 769){
//         let popImageInterval = setInterval(() => {
//             if ($(".page-content--product .product__photos  .image-wrap .zoomImg").length) {
//               $(".page-content--product .product__photos  .image-wrap .zoomImg").each(function(){
//                 $(this).attr("src", "")
//               })
//               clearInterval(popImageInterval);
//             }
//           }, 300);
//     }
    
//   });